import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "width-wrap" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = {
  key: 0,
  class: "form-header"
}
const _hoisted_4 = {
  key: 1,
  class: "form-messages"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_7 = {
  key: 2,
  class: "form-body"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "frm-registerForm_userName" }
const _hoisted_10 = {
  key: 0,
  class: "form-error"
}
const _hoisted_11 = { for: "frm-registerForm_phoneNumber" }
const _hoisted_12 = { class: "multiple-inputs" }
const _hoisted_13 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_14 = {
  key: 0,
  class: "form-error"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "frm-registerForm_email" }
const _hoisted_17 = {
  key: 0,
  class: "form-error"
}
const _hoisted_18 = {
  key: 1,
  class: "form-error"
}
const _hoisted_19 = { for: "frm-registerForm_confirmEmail" }
const _hoisted_20 = { class: "help" }
const _hoisted_21 = {
  key: 0,
  class: "form-error"
}
const _hoisted_22 = {
  key: 1,
  class: "form-error"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { for: "frm-registerForm_password" }
const _hoisted_25 = { class: "help" }
const _hoisted_26 = {
  key: 0,
  class: "form-error"
}
const _hoisted_27 = {
  key: 1,
  class: "form-error"
}
const _hoisted_28 = { for: "frm-registerForm_confirmPassword" }
const _hoisted_29 = { class: "help" }
const _hoisted_30 = {
  key: 0,
  class: "form-error"
}
const _hoisted_31 = {
  key: 1,
  class: "form-error"
}
const _hoisted_32 = { class: "checkbox" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "form-error"
}
const _hoisted_36 = { class: "checkbox" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "form-error"
}
const _hoisted_40 = { class: "buttons-group" }
const _hoisted_41 = { class: "button button--primary" }
const _hoisted_42 = { class: "social-login" }
const _hoisted_43 = ["action"]
const _hoisted_44 = { class: "buttons" }
const _hoisted_45 = {
  key: 0,
  class: "button button--google",
  name: "Provider",
  value: "Google"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("button", {
  class: "button button--facebook",
  name: "Provider",
  value: "Facebook"
}, "Facebook", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("form", {
        id: "registration-form",
        class: "form",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
        autocomplete: "off"
      }, [
        (!_ctx.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('RegistrationUser.title')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFormMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "flashmessage flash-warning",
                    innerHTML: _ctx.$t('RegistrationUser.success-message')
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('RegistrationUser.error-message')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flashmessage flash-danger"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.userName.$error }])
                }, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('RegistrationUser.username')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.userName.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_userName",
                    name: "userName",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.userName.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.userName.$dirty && _ctx.v$.form.userName.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.userName.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
                }, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('RegistrationUser.phoneNumber')) + ":", 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_PhonePrefix, {
                        id: "frm-registerForm_phoneNumberPrefix",
                        modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_phoneNumber",
                      placeholder: "900 000 000",
                      name: "phoneNumber",
                      class: "form-control"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.phoneNumber.$model,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  (_ctx.v$.form.phoneNumber.$dirty && _ctx.v$.form.phoneNumber.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                }, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('RegistrationUser.email')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_email",
                    name: "email",
                    class: "form-control is-required",
                    autocapitalize: "off"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.email.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.email.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.email.email.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('forms.email')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmEmail.$error }])
                }, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('RegistrationUser.email-confirm')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.confirmEmail.$model) = $event)),
                    onPaste: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                    type: "text",
                    id: "frm-registerForm_confirmEmail",
                    name: "confirmEmail",
                    class: "form-control is-required",
                    autocapitalize: "off"
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.v$.form.confirmEmail.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('RegistrationUser.email-help-confirm')), 1),
                  (_ctx.v$.form.confirmEmail.$dirty && _ctx.v$.form.confirmEmail.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.confirmEmail.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.confirmEmail.sameAsEmail.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('RegistrationUser.email-mismatch')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.password.$error }])
                }, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('RegistrationUser.password')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                    type: "password",
                    id: "frm-registerForm_password",
                    name: "password",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.password.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1),
                  (_ctx.v$.form.password.$dirty && _ctx.v$.form.password.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.password.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.password.minLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmPassword.$error }])
                }, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('RegistrationUser.password')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.form.confirmPassword.$model) = $event)),
                    type: "password",
                    id: "frm-registerForm_confirmPassword",
                    name: "confirmPassword",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.confirmPassword.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('RegistrationUser.password-help-confirm')), 1),
                  (_ctx.v$.form.confirmPassword.$dirty && _ctx.v$.form.confirmPassword.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.confirmPassword.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.confirmPassword.sameAsPassword.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('RegistrationUser.password-mismatch')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.generalTermsAgreement.$error }])
              }, [
                _createElementVNode("label", _hoisted_32, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('RegistrationUser.general-terms', { generalTermsUrl: _ctx.generalTermsUrl, domain: _ctx.domain })
                  }, null, 8, _hoisted_33),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.form.generalTermsAgreement.$model) = $event)),
                    type: "checkbox",
                    id: "frm-registerForm_generalTermsAgreement",
                    name: "generalTermsAgreement"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.v$.form.generalTermsAgreement.$model]
                  ]),
                  _hoisted_34
                ]),
                (_ctx.v$.form.generalTermsAgreement.$dirty && _ctx.v$.form.generalTermsAgreement.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.generalTermsAgreement.sameAs.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.personalAgreement.$error }])
              }, [
                _createElementVNode("label", _hoisted_36, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('RegistrationUser.personal-agreement', { privacyUrl: _ctx.privacyUrl, domain: _ctx.domain })
                  }, null, 8, _hoisted_37),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.form.personalAgreement.$model) = $event)),
                    type: "checkbox",
                    id: "frm-registerForm_personalAgreement",
                    name: "personalAgreement"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.v$.form.personalAgreement.$model]
                  ]),
                  _hoisted_38
                ]),
                (_ctx.v$.form.personalAgreement.$dirty && _ctx.v$.form.personalAgreement.$invalid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.v$.form.personalAgreement.sameAs.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", _hoisted_41, _toDisplayString(_ctx.$t('RegistrationUser.button-register')), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createTextVNode(_toDisplayString(_ctx.$t('RegistrationUser.already-has-account')) + " ", 1),
                _createElementVNode("form", {
                  method: "POST",
                  action: _ctx.externalLoginUrl
                }, [
                  _createElementVNode("div", _hoisted_44, [
                    (!_ctx.isFacebookApp)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_45, "Google"))
                      : _createCommentVNode("", true),
                    _hoisted_46
                  ])
                ], 8, _hoisted_43)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}